import { Settings } from './settings';

export const initialSettings: Settings = {
  productId: '',
  currency: 'EUR',
  locale: 'en-US',
  customerCode: '',
};
